/* 
@author : adumoulin
*/

import React, { useContext, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, Navigate } from "react-router-dom";

// Mes imports
import Home from "../views/Home";

import Slidebar from "../component/Slidebar";
import Slidebar_settings from "../component/Slidebar_settings";

import Navbar from "../utils/Navbar";
import Reglages from "./Reglages";
import { HotelContext } from "../context/HotelContext";
import ChoiceHotel from "./ChoiceHotel";
import AjouterHotel from "./AjouterHotel";
import PersonalSettings from "./PersonalSettings";
import AddGroup from "./AddGroup";
import ContenerSaaS from "utils/ContenerSaaS";
import Inscription from "./Inscription";
import Dashboard from "./Dashboard";
import DashboardGM from "./DashboardGM";
import Consommation from "./consommation";
import Economies from "./economies";
import Rooms from "./rooms";
import Donation from "./donation";
import Room_overview from "./Room_overview";
import Translation from "utils/Translation";
import Customer_xp from "./Customer_xp";
import Simulator from "./simulator.js";
import Abonnement from "./Abonnement";
import Rewards from "./Rewards.js";
import ActionsRSE from "./ActionsRSE";
import Badges from "./Badges";
import Statistics from "./Statistiques";
import Homepage from "./Homepage";
import NavbarUser from "utils/NavbarUser";
import Accor from "../img/simulator/Accor_Logo (1) 1.png";
import DeclinedServices from "./DeclinedServices";
import { useV2PreferredRedirect } from "../hooks/useV2PreferredRedirect";

const Base = (props) => {
  const { hId, accessRights, lang, setLang } = useContext(HotelContext);
  const location = useLocation();
  useV2PreferredRedirect();
  const hotelIsSelected = Boolean(hId);
  const path = location.pathname;
  const isSimulatorPage = path.includes("/simulateur-accor-groupe");
  const isGreenMilesPage = path.includes("/greenmiles");

  // Forcer la langue à l'anglais sur les pages GreenMiles
  useEffect(() => {
    if (isGreenMilesPage && lang !== "en") {
      setLang("en");
    }
  }, [isGreenMilesPage, lang, setLang]);

  if (isSimulatorPage) {
    return (
      <div className="App-simulator">
        <Row className="Row_Content">
          {/* <NavbarUser viewID={props.viewID} /> */}
          <Col xs="3" className="sidebarBloc2">
            <Slidebar_settings viewID={props.viewID} path={path} />
          </Col>
          <div className="simulator-header-flex">
            <div className="navbar-flex-grow">
              <NavbarUser viewID={props.viewID} className="navbar navbar-simulator" />
            </div>
            <img src={Accor} alt="Logo Luniwave" className="accor-logo" />
          </div>
          <Col xs="9" className="mainBloc">
            {/* <img src={Accor} alt="Logo Luniwave" className="logo-luniwave-navbar" /> */}
            {/* <div className="mainContent"> */}
            <Simulator />
            {/* </div> */}
          </Col>
        </Row>
      </div>
    );
  }

  if (props.viewID === "homepage") {
    return (
      <div>
        <Homepage />
      </div>
    );
  }

  return (
    <div className="App">
      {props.viewID == "homepage" ? (
        <Homepage />
      ) : (
        <>
          <Row className="Row_Content">
            <Navbar />

            {path.includes("/user/") || !hotelIsSelected ? (
              <Col xs="3" className="sidebarBloc2">
                <Slidebar_settings viewID={props.viewID} path={path} />
              </Col>
            ) : path.includes("/hotel") || path.includes("/settings") ? (
              <Col xs="3" className="sidebarBloc">
                <Slidebar viewID={props.viewID} path={path} />
              </Col>
            ) : null}

            {hId ? (
              path.includes("greenmiles") ? (
                <Col xs="9" className="mainBloc">
                  <div className="mainContent">
                    {props.viewID === "dashboardGM" && <DashboardGM />}
                    {props.viewID === "gmActionsRSE" && <ActionsRSE />}
                    {props.viewID === "gmRewards" && <Rewards />}
                    {props.viewID === "declinedServices" && <DeclinedServices />}
                    {!["dashboardGM", "gmActionsRSE", "gmRewards", "declinedServices"].includes(props.viewID) && <Translation tag="Connection_required_Hotel" />}
                  </div>
                </Col>
              ) : (
                <Col xs="9" className="mainBloc">
                  <div className="mainContent">
                    {props.viewID === "dashboard" && <Dashboard />}
                    {props.viewID === "consommation" && <Consommation />}
                    {props.viewID === "economies" && <Economies />}
                    {props.viewID === "room" && <Room_overview />}
                    {props.viewID === "rooms" && <Rooms />}
                    {props.viewID === "donation" && (!accessRights?.RSE ? <Navigate to="/hotel/lunishower/dashboard" replace /> : <Donation />)}
                    {props.viewID === "main" && <Home />}
                    {props.viewID === "hotelInformations" && <Reglages />}
                    {props.viewID === "myAccess" && <Home />}
                    {props.viewID === "customer_xp" && (!accessRights.EXP ? <Navigate to="/hotel/lunishower/dashboard" replace /> : <Customer_xp />)}
                    {props.viewID === "rooms_settings" && <Home />}
                    {props.viewID === "devices" && <Home />}
                    {props.viewID === "badges" && <Badges />}
                    {props.viewID === "stats" && <Statistics />}
                  </div>
                </Col>
              )
            ) : path.includes("greenmiles") ? (
              <Col xs="10" className="mainBloc">
                <div className="mainContent">
                  {props.viewID === "dashboardGM" && <DashboardGM />}
                  {props.viewID === "gmActionsRSE" && <ActionsRSE />}
                  {props.viewID === "gmRewards" && <Rewards />}
                  {props.viewID === "declinedServices" && <DeclinedServices />}
                  {!["dashboardGM", "gmActionsRSE", "gmRewards", "declinedServices"].includes(props.viewID) && <Translation tag="Connection_required_Hotel" />}
                </div>
              </Col>
            ) : (
              <Col xs="10" className="mainBloc">
                <div className="mainContent">
                  {props.viewID === "personalInformations" && <PersonalSettings />}
                  {props.viewID === "addHotel" && <AjouterHotel />}
                  {props.viewID === "myHotels" && <ChoiceHotel />}
                  {props.viewID === "addGroup" && (
                    <ContenerSaaS title="Créer un groupe" notMaxHeight>
                      <AddGroup type={"create"} />
                    </ContenerSaaS>
                  )}
                  {!["personalInformations", "addHotel", "myHotels", "addGroup"].includes(props.viewID) && <Translation tag="Connection_required_Hotel" />}
                </div>
              </Col>
            )}
          </Row>
        </>
      )}
    </div>
  );
};

export default Base;
